/**
 * @see https://stackoverflow.com/a/31732310
 */
export default function isSafariMobile() {
  return 'ontouchstart' in window && navigator.vendor != null && navigator.vendor.includes('Apple') && navigator.userAgent != null && !navigator.userAgent.includes('CriOS') && !navigator.userAgent.includes('FxiOS');
}
flarum.reg.add('core', 'forum/utils/isSafariMobile', isSafariMobile);